import {
  FeedbackContent,
  FeedbackLabel,
  FeedbackMessage,
  FeedbackRoot,
  FeedbackSkeleton,
  ShopActionFeedbackTone,
} from "./styles";

interface ShopActionFeedbackProps {
  message?: string;
  tone?: ShopActionFeedbackTone;
  stackIndex?: number;
}

const LABELS: Record<ShopActionFeedbackTone, string> = {
  success: "Erledigt",
  error: "Hinweis",
};

const ShopActionFeedback = ({ message, tone = "success", stackIndex = 0 }: ShopActionFeedbackProps) => {
  if (!message?.trim()) {
    return null;
  }

  return (
    <FeedbackRoot $tone={tone} $stackIndex={stackIndex} role={tone === "error" ? "alert" : "status"} aria-live="polite">
      <FeedbackSkeleton variant="rounded" animation="wave" $tone={tone} />
      <FeedbackContent>
        <FeedbackLabel $tone={tone}>{LABELS[tone]}</FeedbackLabel>
        <FeedbackMessage $tone={tone}>{message}</FeedbackMessage>
      </FeedbackContent>
    </FeedbackRoot>
  );
};

export default ShopActionFeedback;
